// extracted by mini-css-extract-plugin
module.exports = {"products":"AV","productContainer":"BV","overFlowVisible":"CV","resultsHeading":"DV","oosMessaging":"EV","bestExp":"FV","bestExpRecognized":"GV","bestExpMobile":"HV"};